import type {
  GetContextMenuItemsParams,
  ICellRendererParams,
} from "ag-grid-community";
import type { CellReviewCellIdentity } from "../shared/cellReviews/useCellReviewContextMenu";
import type { ResponsesGridRow } from "./types";

const deriveCell = (
  carrierId: string | undefined,
  field: string | undefined,
): CellReviewCellIdentity | null =>
  carrierId && field ? { planId: carrierId, fieldPath: field } : null;

/** Resolves the cell-review identity for ResponsesCellRenderer. */
export const deriveResponsesCellForRenderer = (
  params: ICellRendererParams<ResponsesGridRow>,
): CellReviewCellIdentity | null =>
  deriveCell(params.data?.carrierId, params.colDef?.field);

/** Resolves the cell-review identity for the AG Grid context menu. */
export const deriveResponsesCellForContextMenu = (
  params: GetContextMenuItemsParams<ResponsesGridRow>,
): CellReviewCellIdentity | null =>
  deriveCell(params.node?.data?.carrierId, params.column?.getColDef()?.field);
